module.exports = __webpack_public_path__ + "static/media/bg.1b22e3b6.jpg";